module.exports = __webpack_public_path__ + "static/media/astralito_web_favicon.93ab2f52.png";